module.exports = __webpack_public_path__ + "img/limorecloud_logo.97e1b640.png";